<template>
  <div class="new-promotion" ref="scroll" style="padding-bottom: 0">
    <!-- 新建推广 -->
    <div class="promotion-box">
      <!-- 右边导航 -->
      <Navigation
        class="promotion-left"
        :currentIndex="currentIndex"
        :nav-list="navList"
        @on-click-first-nav="onClickFirstNav"
        @on-click-second-nav="onClickSecondNav"
        @on-click-return="onClickReturn"
      />
      <!-- 左边表单 -->
      <section class="promotion-right">
        <!--广告系列 -->
        <Series
          v-show="currentIndex == 0"
          @submit="onSubmit(0)"
          @next-step="nextStep(0)"
        />
        <!-- 广告组 -->
        <Campaign
          v-show="currentIndex == 1"
          @submit="onSubmit(1)"
          @next-step="nextStep"
          @last-step="currentIndex = 0"
        />
        <!-- 广告组预览 -->
        <CampaignPreview
          v-show="currentIndex == 2"
          :flag.sync="flag"
          @submit="onSubmit(2)"
          @next-step="nextStep"
          @last-step="currentIndex = 1"
        />
        <!-- 创意 -->
        <Creative
          v-show="currentIndex == 3"
          @submit="onSubmit(3)"
          @last-step="currentIndex = 1"
        />
      </section>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/NewPromotion/navigation.vue";
import Series from "./Series.vue";
import Campaign from "./Campaign.vue";
import CampaignPreview from "./CampaignPreview.vue";
import Creative from "./Creative/Creative.vue";
import Stickybits from "stickybits";
import mixins from "@/mixins/index";
import _ from 'lodash';

export default {
  name: "NewPromotion",
  mixins: [mixins],
  components: {
    Navigation,
    Series,
    Campaign,
    CampaignPreview,
    Creative,
  },
  data() {
    return {
      //广告组预览是否有修改
      flag: false,
      // 当前索引
      currentIndex: 0,
      //固定的翻译
      language: {
        pt: "Baixar",
        es: "Descargar",
        in: "Unduh",
        ko: "다운로드",
        ru: "скачать",
        ar: "تحميل",
        vi: "Tải về",
        fr: "Obtenir",
        th: "ดาวน์โหลด",
        hi: "डाउनलोड",
        ja: "打ち上げ",
        fa: "دانلود",
        iw: "הורד",
        ms: "Muat turun",
      },
      //导航列表
      navList: [
        {
          title: "广告系列",
          status: "active",
          children: [
            { title: "基础信息", active: false, hash: "base" },
            { title: "投放信息", active: false, hash: "ad" },
            // { title: "其他设置", active: true, hash: "other" },
          ],
        },
        {
          title: "广告组",
          status: "notActive",
          children: [
            { title: "定向条件", active: false, hash: "direct" },
            { title: "媒体选择", active: false, hash: "media" },
            { title: "预算排期", active: false, hash: "budget" },
            { title: "自动优化", active: false, hash: "optimization" },
          ],
        },
        {
          title: "广告组预览",
          status: "disabled",
          children: [{ title: "广告组预览", active: true, hash: "" }],
        },
        {
          title: "广告",
          status: "notActive",
          children: [{ title: "创意上传", active: false, hash: "creative" }],
        },
      ],
      bidTypeList: {
        1: { label: "CPM", min: "0.01" },
        2: { label: "CPA", min: "0.03" },
        3: { label: "CPC", min: "0.0006" },
      },
    };
  },
  computed: {
    action() {
      return this.$route.query.action;
    },
    type() {
      return this.$route.query.type;
    },
    id() {
      return this.$route.query.id;
    },
    publisherId() {
      return this.$route.query.publisherId;
    },
    status() {
      return this.$store.state.newPromotion.status;
    },
    userData() {
      return this.$store.state.userData;
    },
    seriesParams() {
      return this.$store.state.newPromotion.seriesParams;
    },
    campaignParams() {
      return this.$store.state.newPromotion.campaignParams;
    },
    campaignBatchList() {
      return this.$store.state.newPromotion.campaignBatchList;
    },
    batch() {
      return this.$store.state.newPromotion.campaignParams.batch;
    },
    creativeParams() {
      return this.$store.state.newPromotion.creativeParams;
    },
    creativeType() {
      return this.$store.state.newPromotion.creativeType;
    },
    seriesError() {
      return this.$store.getters.seriesError;
    },
    campaignError() {
      return this.$store.getters.campaignError;
    },
    creativeError() {
      return this.$store.getters.creativeError;
    },
    //导航高亮检测
    navActiveList() {
      const seriesError = this.seriesError;
      const campaignError = this.campaignError;
      const creativeError = this.creativeError;
      const creativeType = this.creativeType;
      return [
        [
          !seriesError.name && !seriesError.campaignType,
          !seriesError.clickUrl,
          true,
        ],
        [
          !campaignError.targetIps,
          !campaignError.targetSourceChannelIds,
          !campaignError.name &&
            !campaignError.bidPrice &&
            !campaignError.dailyBudget,
          true,
        ],
        [true],
        [!creativeError[creativeType]],
      ];
    },
    sourceList() {
      return this.$store.state.newPromotion.sourceList;
    },
    countryList() {
      return this.$store.state.newPromotion.countryList;
    },
    languageList() {
      return this.$store.state.newPromotion.languageList;
    },
    categoryList() {
      return this.$store.state.newPromotion.categoryList;
    },
    seriesList() {
      return this.$store.state.newPromotion.seriesList;
    },
    campaignList() {
      return this.$store.state.newPromotion.campaignList;
    },
    osList() {
      return this.$store.state.newPromotion.osList;
    },
    appList() {
      return this.$store.state.newPromotion.appList;
    },
    bundleList() {
      return this.$store.state.newPromotion.bundleList;
    },
  },
  watch: {
    //更新navLis导航的状态
    navActiveList: {
      handler: function(newValue) {
        this.navList.forEach((first, firstIndex) => {
          first.children.forEach(
            (second, secondIndex) =>
              (second.active = newValue[firstIndex][secondIndex])
          );
        });
      },
      immediate: true,
    },
    batch: {
      handler: function(newValue) {
        this.navList[2].status = this.batch ? "notActive" : "disabled";
      },
      immediate: true,
    },
  },
  created() {
    const action = this.action,
      type = this.type,
      id = this.id,
      navList = this.navList;
    this.$store.commit("status", { action, type, id });
    this.$store.commit("userInfo", this.userData);

    //不同类型
    if (type == "campaign") {
      navList[0].status = "disabled";
      navList[1].status = "active";
      this.currentIndex = 1;
      this.seriesParams.level = 2;
    }
    if (type == "creative") {
      navList[0].status = "disabled";
      navList[1].status = "disabled";
      navList[3].status = "active";
      this.currentIndex = 3;
      this.seriesParams.level = 3;
    }
    //不同的操作
    if (action == "add") {
      if (type == "series") {
        this.getSourceList();
      }
      if (type == "campaign") {
        if (id) this.getDetail("series").then(() => this.getSourceList());
        else {
          this.getSourceList();
          this.getCampaignSeriesList();
        }
      }
      if (type == "creative") {
        if (id) this.getDetail("campaign").then(() => this.getSourceList());
        else {
          this.getSourceList();
          this.getCampaignList();
        }
      }
    } else if (action == "copy") {
      this.getDetail(type).then(() => this.getSourceList());
      if (type == "campaign") this.getCampaignSeriesList();
      else if (type == "creative") this.getCampaignList();
    } else if (action == "edit") {
      this.getDetail(type).then(() => this.getSourceList());
    }
    //获取列表
    this.getCountryList();
    this.getLanguageList();
    this.getOsList();
    this.getCategoryList();
    this.getBundleList();
    this.getAppList();
  },
  mounted() {
    //给导航栏添加sticky样式
    Stickybits(".promotion-left");
  },
  methods: {
    /**
     * @desc 获取广告系列列表
     */
    async getCampaignSeriesList() {
      if (!this.seriesList.length) {
        const res = await this.$axios.get(
          this.$port.series.getCampaignSeriesList
        );
        this.$store.commit("seriesList", res.data || []);
      }
    },
    /**
     * @desc 获取广告系列列表
     */
    async getCampaignList() {
      if (!this.campaignList.length) {
        const params = {
          page: 1,
          pageSize: 100000,
        };
        const res = await this.$axios.get(this.$port.report.campaignSearch, {
          params,
        });
        this.$store.commit("campaignList", res.data.list || []);
      }
    },
    /**
     * @desc 获取包名
     */
    async getAppList() {
      if (!this.appList.length) {
        const res = await this.$axios.get(this.$port.manager.getAppList, {
          params: { platform: "" },
        });
        this.$store.commit("appList", res.data.apps || []);
      }
    },
    /**
     * @desc 获取国家
     */
    async getCountryList() {
      if (!this.countryList.length) {
        const res = await this.$axios.get(this.$port.manager.getCountryList);
        this.$store.commit("countryList", res.data || []);
      }
    },
    /**
     * @desc 获取语言列表
     */
    async getLanguageList() {
      if (!this.languageList.length) {
        const res = await this.$axios.get(this.$port.manager.getLanguageList);
        this.$store.commit("languageList", res.data || []);
      }
    },
    /**
     * @desc 获取os列表
     */
    async getOsList() {
      if (!this.osList.length) {
        const res = await this.$axios.get(this.$port.manager.getOsList);
        this.$store.commit("osList", res.data || []);
      }
    },
    /**
     * @desc 获取渠道广告位列表
     */
    async getSourceList() {
      const res = await this.$axios.get(this.$port.manager.getSourceList);
      this.$store.commit("sourceList", res.data.sources || []);
      const targetSourceChannelIds = this.campaignParams.targetSourceChannelIds;
      //补充广告位
      if (targetSourceChannelIds.length) {
        targetSourceChannelIds.forEach((item) =>
          this.sourceList.forEach((cell) => {
            if (cell.id == item.sourceId) {
              item.name = cell.name;
              item.adsenses = cell.adsenses;
            }
          })
        );
      }
      //默认选择第一个渠道
      if (this.status.action == "add" || this.status.type == "series") {
        targetSourceChannelIds.push({
          sourceId: this.sourceList[0].id,
          type: 0,
          ids: "",
          name: this.sourceList[0].name,
          adsenses: this.sourceList[0].adsenses,
        });
      }
    },
    /**
     * @desc 获取媒体分类
     */
    async getCategoryList() {
      if (!this.categoryList.length) {
        const res = await this.$axios.get(this.$port.manager.getCategoryList);
        this.$store.commit("categoryList", res.data.list || []);
      }
    },
    /**
     * @desc 获取媒体
     */
    async getBundleList() {
      if (!this.bundleList.length) {
        const res = await this.$axios.get(this.$port.manager.listBundles);
        this.$store.commit(
          "bundleList",
          (res.data || []).map((item) => ({ name: item }))
        );
      }
    },
    /**
     * @desc 获取广告系列、广告组、广告详情
     * @param {String} type 类型： series campaign creative
     */
    async getDetail(type) {
      const status = this.status;
      const typeIndex = { series: 1, campaign: 2, creative: 3 }[type];
      const res = await this.$axios.get(this.$port.series.getDetail, {
        params: {
          id: this.status.id,
          type: typeIndex,
          publisherId: this.publisherId,
        },
      });
      if (!res.data) {
        return
      }
      // 复制的话，删除id
      if (status.action == "copy") {
        if (status.type == "series") {
          res.data.campaignSeries.name += "_复制";
          delete res.data.campaignSeries.id;
        }
        if (status.type == "campaign") {
          res.data.campaign.name += "_复制";
          delete res.data.campaign.id;
        }
        if (status.type == "creative") {
          res.data.offer.name += "_复制";
          res.data.offer.copyId = res.data.offer.id;
          delete res.data.offer.id;
        }
      }

      // 广告系列处理
      if (typeIndex >= 1) {
        const series = res.data.campaignSeries || {};
        if (series.dailyBudget) {
          series.dailyBudgetType = "dailyBudget";
          series.dailyBudgetValue = series.dailyBudget;
        }
        if (series.dailyClick) {
          series.dailyBudgetType = "dailyClick";
          series.dailyBudgetValue = series.dailyClick;
        }
        if (series.dailyImp) {
          series.dailyBudgetType = "dailyImp";
          series.dailyBudgetValue = series.dailyImp;
        }
        series.totalBudget = series.totalBudget ? series.totalBudget : "";
        series.frequency = series.frequency ? series.frequency : "";
        series.dayType = series.startDay ? 1 : 0;
        if (!series.startDay) {
          series.startDay = this.mixinGetDate("today"); //日期
          series.endDay = this.mixinGetDate("day", 6); //日期
        }
        // if(series.appBundle != ''){}
        series.appBundleJY = series.appBundle != "" ? true : false;
        // 将appId转为数字类型
        series.appId = Number(series.appId);
        // 从series中排除不要的字段（有些没用的字段后端没用清除）
        const pickValidSeries = _.omit(series, [
          "appBundle",
          "campaignType",
          "clickUrl",
          "conversionEvent",
          "impCallbackUrl",
          "clickCallbackUrl",
        ]);

        this.$store.commit("seriesParams", {
          ...this.seriesParams,
          //   ...series,
          ...pickValidSeries,
        });
      }

      //广告组处理
      if (typeIndex >= 2) {
        const ipList = this.$store.state.newPromotion.ipList;
        const campaign = {
          ...this.campaignParams,
          ...res.data.campaign,
        };
        //ip处理
        if (campaign.targetIps) {
          campaign.targetIps.split(",").forEach((item, index) => {
            if (item.indexOf("-") > -1) {
              const ips = item.split("-");
              ipList[index] = { start: ips[0], end: ips[1] };
            }
          });
        }
        //os处理
        let str = campaign.targetOs.split(":");
        str = str[str.length > 1 ? 1 : 0];
        campaign.targetOs = str == "android;ios" ? "" : str;
        campaign.targetTimeType = campaign.targetTime ? 1 : 0;
        if (campaign.dailyBudget) {
          campaign.dailyBudgetType = "dailyBudget";
          campaign.dailyBudgetValue = campaign.dailyBudget;
        }
        if (campaign.dailyClick) {
          campaign.dailyBudgetType = "dailyClick";
          campaign.dailyBudgetValue = campaign.dailyClick;
        }
        if (campaign.dailyImp) {
          campaign.dailyBudgetType = "dailyImp";
          campaign.dailyBudgetValue = campaign.dailyImp;
        }
        if (campaign.startTime && campaign.endTime) {
          campaign.pbidPriceTime = [campaign.startTime, campaign.endTime];
        } else {
          campaign.pbidPriceTime = [];
        }
        console.log("campaign", campaign);
        this.$store.commit("ipList", ipList);
        this.$store.commit("campaignParams", campaign);
      }

      //广告处理
      if (typeIndex >= 3) {
        const offer = res.data.offer || {};
        //创意类型
        let creativeType = offer.creativeType;
        if (creativeType == 1 && (offer.h5Type == 1 || offer.h5Type == 2)) {
          creativeType = 11;
          this.$store.commit("htmlList", [
            {
              creativeType: 1,
              title: "",
              h5Type: 2,
              h5Url: "",
              status: 1,
              sizeType: 6,
              ...offer,
            },
          ]);
        }
        if (creativeType == 1) {
          offer.showFunction = false;
          this.$store.commit("imgList", [offer]);
        }
        if (creativeType == 2 || creativeType == 5) {
          if (status.action == "edit") {
            this.$store.commit("infoParams", {
              creativeType: creativeType,
              status: offer.status,
              iconUrl: offer.iconUrl,
              sizeType: offer.sizeType == 9 ? 7 : offer.sizeType,
              textList: [
                {
                  name: offer.name,
                  title: offer.title,
                  description: offer.description,
                  buttonText: offer.buttonText,
                },
              ],
              imgList: [
                {
                  name: offer.name,
                  imgUrl: offer.imgUrl,
                  sizeType: offer.sizeType,
                  showFunction: false,
                },
              ],
              nativeImgList: [],
            });
          } else if (status.action == "copy") {
            this.$store.commit("infoList", [{ ...offer }]);
          }
        }
        if (creativeType == 4) {
          const imgList = offer.imgUrl.split(",");
          imgList.push(
            ...new Array({ 1: 3, 2: 5 }[offer.animation] - imgList.length).fill(
              ""
            )
          );
          this.$store.commit("bannerList", [
            {
              ...offer,
              bgLoading: false,
              bgFunction: false,
              bgSizeType: offer.sizeType,
              imgList: imgList.map((img) => ({
                imgUrl: img ? img : "",
                sizeType: offer.sizeType,
                loading: false,
                function: false,
              })),
            },
          ]);
        }
        if (creativeType == 3) {
          offer.showFunction = false;
          this.$store.commit("videoList", [offer]);
        }
        this.$store.commit("creativeType", creativeType);
      }
    },
    /**
     * @desc 点击一级导航，跳转到对应栏目
     * @param {Number} index 点击的导航索引
     */
    onClickFirstNav(index) {
      //未激活无法跳转
      if (this.navList[index].status != "active") return;
      //批量新建，禁止跳转
      if (this.currentIndex == 1 && this.batch) {
        this.$Message.warning({
          content: "批量新建，禁止跳转!",
          duration: 1.5,
        });
        return;
      }
      if (this.currentIndex == 2 && index == 1 && this.flag) {
        this.$Modal.confirm({
          content: "修改变量将重置广告组预览的设置，是否继续操作？",
          onOk: () => {
            this.currentIndex = index;
            location.hash = "";
            document.querySelector(
              "#app"
            ).scrollTop = document.documentElement.scrollTop = document.body.scrollTop = 0;
            this.flag = false;
          },
        });
        return;
      }
      //验证表单
      if (index > this.currentIndex) {
        if (!this.validateParams(this.currentIndex)) return;
      }
      this.currentIndex = index;
      location.hash = "";
      document.querySelector(
        "#app"
      ).scrollTop = document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    /**
     * @desc 点击二级导航
     * @param {Object} obj { firstIndex:一级导航索引，hash:对应的hash值 }
     */
    onClickSecondNav(obj) {
      this.onClickFirstNav(obj.firstIndex);
      //hash定位
      location.hash = obj.hash;
    },
    /**
     * @desc 保存广告系列，广告组，广告
     * @param {Number} index 类型
     */
    async onSubmit(index) {
      const status = this.status;
      let params;
      // debugger

      if (this.seriesParams.level == 1) {
        params = { ...this.seriesParams };
        params.totalBudget = ~~params.totalBudget;
        params.dailyBudget = 0;
        params.dailyImp = 0;
        params.dailyClick = 0;
        params[params.dailyBudgetType] = ~~params.dailyBudgetValue;
        if (!params.frequency) params.frequency = 0;
        if (!params.dayType) {
          params.startDay = "";
          params.endDay = "";
        }
      } else {
        params = {
          id: this.seriesParams.id,
          level: this.seriesParams.level,
        };
      }

      if (status.type == "series") if (!this.validateParams(0)) return;

      if (index >= 1) {
        if (status.type == "series" || status.type == "campaign")
          if (!this.validateParams(1)) return;
        if (params.level == 3) {
          params.campaigns = [{ id: this.campaignParams.id }];
        } else {
          const targetOsType = this.campaignParams.targetOsType;
          let targetOs = "";
          if (targetOsType == 0) targetOs = "android;ios";
          else {
            targetOs = { 1: "ios", 2: "android" }[targetOsType];
            if (this.campaignParams.targetOs)
              targetOs += `:${this.campaignParams.targetOs}`;
          }
          //批量
          if (this.campaignParams.batch) {
            params.campaigns = this.campaignBatchList.map((item) => ({
              ...item,
              targetIps: this.$store.state.newPromotion.ipList
                .filter((item) => item.start)
                .map((item) => `${item.start}-${item.end}`)
                .join(","),
              targetOs,
            }));
          } else {
            params.campaigns = [
              {
                ...this.campaignParams,
                targetIps: this.$store.state.newPromotion.ipList
                  .filter((item) => item.start)
                  .map((item) => `${item.start}-${item.end}`)
                  .join(","),
                targetOs,
              },
            ];
            if (status.copyOffers) {
              params.campaigns[0].copyId = status.id;
              params.campaigns[0].copyOffers = 1;
            }
          }
          //删除广告位
          params.campaigns.forEach((campaign) => {
            // campaign.bidType == 2; //固定CPA出价
            campaign.dailyBudget = 0;
            campaign.dailyImp = 0;
            campaign.dailyClick = 0;
            campaign[campaign.dailyBudgetType] = ~~campaign.dailyBudgetValue;
            if (this.userData.autoType == 1)
              campaign.dailyImpCpmTimes = ~~campaign.dailyImpCpmTimes;
            campaign.targetSourceChannelIds.forEach((item) => {
              delete item.adsenses;
              delete item.name;
            });
          });
        }
        if (index >= 3) {
          if (!this.validateParams(2)) return;
          if (status.type == "creative" && status.action == "edit")
            this.creativeParams[0].id = status.id;
          if (status.type == "creative" && status.action == "copy")
            this.creativeParams[0].copyId = status.id;
          if (
            this.campaignParams.batch &&
            this.campaignParams.translate &&
            this.creativeType == 2
          ) {
            //翻译
            const resTranslate = await this.$axios.post(this.$port.translate, {
              targetLanguages: this.languageList
                .filter((item) => item.code != "unknown")
                .map((item) => item.code),
              texts: this.creativeParams.map((item, index) => [
                item.title,
                item.description,
                item.buttonText,
              ]),
            });
            //注入到offer
            params.campaigns.forEach((campaign) => {
              campaign.offers = [];
              resTranslate.data.forEach((textGroup) => {
                if (textGroup.lang == campaign.targetLanguages) {
                  textGroup.translatedTexts.forEach((text, index) => {
                    campaign.offers.push({
                      ...this.creativeParams[index],
                      title: text[0],
                      description: text[1],
                      buttonText:
                        textGroup.lang == "en"
                          ? text[2]
                          : this.language[textGroup.lang], //固定按钮文案
                    });
                  });
                }
              });
            });
          } else {
            params.campaigns.forEach((campaign) => {
              campaign.offers = this.creativeParams;
            });
          }
        }
      }
      params.publisherId = this.publisherId;

      console.log("params", params);

      const res = await this.$axios.post(this.$port.series.addOrUpdate, params);
      if (res.status != 200) {
        this.$Modal.error({ title: "提交失败", content: "提交失败，请重试！" });
      } else {
        const statusEnum = {
          series: "series",
          campaign: "group",
          creative: "item",
        };
        this.$Modal.success({
          title: "提交成功",
          content: "已提交并保存成功，请点击确定返回管理页面",
          onOk: () =>
            this.$router.replace(`/adv/${statusEnum[this.status.type]}`),
        });
      }
    },
    /**
     * @desc 下一步
     * @param {Number} index 类型 下一步的索引
     */
    nextStep(index) {
      if (index == "0" && !this.validateParams("0")) return;
      if ((index == "1" || index == "2") && !this.validateParams("1")) return;
      this.currentIndex = index + 1;
      this.navList[this.currentIndex].status = "active";
      location.hash = "";
      document.querySelector(
        "#app"
      ).scrollTop = document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    /**
     * @desc 验证参数
     * @param {String} type 验证索引
     * @return {Boolean} 验证是否成功
     */
    validateParams(type) {
      const status = this.status;
      const message = [];
      if (type == "0") {
        const seriesError = this.seriesError;
        if (seriesError.name) message.push("请填写广告系列名称");
        if (seriesError.campaignType) message.push("请选择行业");
        if (seriesError.clickUrl) message.push("请填写落地页链接");
        if (seriesError.dailyBudget) message.push("日预算不能为0");
        if (seriesError.totalBudget) message.push("总预算不能为0");
      }
      if (type == "1") {
        const campaignError = this.campaignError;
        const bidTypeList = this.bidTypeList;
        const campaignParams = this.campaignParams;
        if (
          status.type == "campaign" &&
          campaignError.seriesId &&
          ((status.action == "add" && !status.id) || status.action == "copy")
        )
          message.push("请选择广告系列");
        if (campaignError.targetSourceChannelIds) message.push("请选择渠道");
        if (campaignError.targetIps) message.push("请输入两条正确的IP起止地址");
        if (campaignError.name) message.push("请填写广告组名称");
        if (campaignError.dailyBudget)
          message.push("日预算不能为0，并且消耗不限时，不允许选择匀速");
        if (campaignError.bidPrice)
          message.push(
            `${bidTypeList[campaignParams.bidType].label}出价不得小于${
              this.userData.source == "batmobi"
                ? 0
                : bidTypeList[campaignParams.bidType].min
            }`
          );
      }
      if (type == "2") {
        const creativeError = this.creativeError;
        if (
          status.type == "creative" &&
          creativeError.campaignId &&
          ((status.action == "add" && !status.id) || status.action == "copy")
        )
          message.push("请选择广告组");
        if (creativeError[this.creativeType])
          message.push("未生成广告或填写信息有误");
      }
      if (message.length) {
        this.$Message.destroy();
        message.forEach((item) =>
          this.$Message.error({ content: item, duration: 2 })
        );
        return false;
      }
      return true;
    },
    /**
     * @desc 点击离开页面
     */
    onClickReturn() {
      this.$Modal.confirm({
        title: "是否要离开此页面",
        content: "是否要离开此页面?",
        onOk: () =>
          this.$router.replace(`/promotionManagement/${this.status.type}`),
      });
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "src/style/frequently";
.promotion-box {
  display: flex;
  border-radius: $bdRadius;
  max-width: 14.18rem;
  min-width: 13.58rem;
  margin: 0.3rem auto 0 auto;
  box-sizing: border-box;
  .ivu-input-group-prepend,
  .ivu-input-group-append {
    background: none;
    font-size: 0.14rem;
    width: 0.7rem;
    & > span {
      position: relative;
      top: 1px;
    }
  }
  .ivu-select {
    position: relative;
    // z-index: 1000;
  }
  // background-color: #fff;
  // border: 1px solid #dee2e5;
  // border-radius: 0.04rem;
  .promotion-left {
    padding-top: 0.3rem;
    flex: 0 0 2.68rem;
    background: white;
    box-shadow: 1px 1px 14px 1px hsla(0, 0%, 39%, 0.2);
    box-sizing: border-box;
    border-radius: $bdRadius;
  }
  .promotion-right {
    flex: 1 1 auto;
    flex-direction: column;
    padding-left: 0.4rem;
    box-sizing: border-box;
  }
  .panel-btn {
    padding: 0.2rem 0.5rem;
  }
  .panel {
    padding: 0.3rem 0.5rem;
    border: $border;
    background: white;
    box-shadow: 1px 1px 14px 1px hsla(0, 0%, 39%, 0.2);
    box-sizing: border-box;
    border-radius: $bdRadius;
    margin-bottom: 0.3rem;
    .ivu-input,
    .ivu-select-input,
    .ivu-select-selected-value,
    .ivu-select-selection {
      height: 0.36rem;
      font-size: 0.14rem;
    }
    .ivu-select-selected-value {
      line-height: 0.36rem !important;
    }
    .ivu-input-icon {
      line-height: 0.36rem;
      height: 0.36rem;
    }

    &-title {
      font-size: 0.2rem;
      color: #333;
      font-weight: 700;
      margin-bottom: 0.4rem;
    }
    &-row {
      position: relative;
      max-width: 5.48rem;
      &:not(:nth-last-of-type(1)) {
        margin-bottom: 0.36rem;
      }
      //字段名
      &-label {
        margin-bottom: 0.12rem;
        font-size: 0.16rem;
        line-height: 0.22rem;
        height: 0.22rem;
        color: #888;
        display: flex;
        align-items: center;
        &.macro {
          justify-content: space-between;
        }
      }
      //错误样式
      &-error {
        margin-left: 0.3rem;
        display: inline-flex;
        align-items: center;
        color: #fd5f65;
        &-icon {
          margin-right: 0.1rem;
          font-size: 0.18rem;
        }
      }
      //radio-group
      &-radio-group {
        display: flex;
        line-height: 0.3rem;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/NewPromotion.vue